<template>
  <div v-if="!this.loading" class="animated fadeIn">
    <b-container fluid>
      <b-card>
        <b-row>
          <b-col cols="3" class="pull-right m-3">
            <b-btn block variant="primary" @click="goBack"><i class="fa fa-arrow-left fa-lg"></i> Volver</b-btn>
          </b-col>
          <b-col lg="12">
            <formDinamic :typeEndPoint="this.form.formSchema.method" :formSchema="this.form.formSchema" :formData="this.form.formData" :params="this.dataParams" />
          </b-col>
        </b-row>
      </b-card>
    </b-container>
  </div>
</template>
<script>
import formDinamic from '@/views/base/form/Form.vue'
// import { mapGetters } from 'vuex'
export default {
  name: 'Form',
  components: {
    formDinamic
  },
  props: {
    mapState: { required: true },
    typeEndPoint: { required: true },
    dataParams: {}
  },
  data () {
    return {
      loading: true,
      form: {},
      dataLoad: {}
    }
  },
  computed: {
    // ...mapGetters({
    // users: 'users'
    // })
  },
  mounted () {
    console.log(this.dataParams)
    let object = {}
    object = this.dataParams
    let json = JSON.stringify(object)
    this.$store.dispatch(this.typeEndPoint, json).then((response) => {
      this.form = this.$store.getters[this.mapState]
      this.loading = false
    }).catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
  },
  methods: {
    goBack: function () {
      window.history.back()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/base/form.vue